import React from "react";
import {
  Link,
  Switch,
  Route,
  BrowserRouter
} from "react-router-dom";
import { Helmet } from "react-helmet";


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


import caseMathem from '../images/casestudy-mathem.png';


function Navigation() {
  const [title, setTitle] = React.useState("")

  const [isOpen, setIsOpen] = React.useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Row>
      <Col xs={12} md={9} lg={8} xl={6}>
        <h1 className="header-section">Case studies</h1>
        <div className="Case-study">
          <Link to="/mathem">
            <div className="img-holder">
              <img src={caseMathem} alt="Mathem Case Study" width="100%" />
            </div>
            <p className="case-link">Mathem visual update <span class="material-icons-small">east</span></p>
          </Link>
        </div>
      </Col>
      <Col>

      </Col>
    </Row>
  );
}

export default Navigation;
